mutation savePropstackChildTeamAssignment($input: PropstackChildTeamAssignmentInput!) {
  savePropstackChildTeamAssignment(input: $input) {
    companyId
    teamId
  }
}
